import { subjects } from './';

export const handleResponse = async (response, isStream = false) => {
  if (response) {
    // if a fetch call is aborted, response will be empty
    try {
      if (!response.ok) {
        const res = await response.text();

        let error = '';

        if ([400, 409, 500].indexOf(response.status) !== -1) {
          try {
            error = JSON.parse(res);
          } catch (e) {
            error = res;
          }
        } else if ([401, 403].indexOf(response.status) !== -1) {
          subjects.isLoggedIn.next(false);
          subjects.loggedInUser.next({});

          error = JSON.parse(res);
          error = { message: error.message, error: error.error };
        } else if ([404].indexOf(response.status) !== -1) {
          error = { message: 'Requested service not found', error: response.url, status: 404 };
        } else if (response.status === 429) {
          error = JSON.parse(res);
        } else if (!response) {
          error = { message: 'Unknown error', error: JSON.parse(res) };
        }

        return Promise.reject(error);
      }

      if (isStream) {
        return response;
      } else {
        const res = await response.text();
        try {
          const data = JSON.parse(res);
          return data;
        } catch (e) {
          return res;
        }
      }
    } catch (e) {
      if (e.name === 'AbortError') {
        // this should not be necessary here, but some fetch aborts are leaked from customFetch
        return;
      }

      return Promise.reject(e);
    }
  } else {
    return Promise.resolve();
  }
};
